import { Stack, Flex, Heading, Box } from "@chakra-ui/react";
import type { SbEditableComponentProps } from "types/storyblok";
import { Container } from "components";
import { WhyChooseCard } from "./WhyChooseCard";
import type { WhyChooseAirHelpProps } from "./WhyChooseAirHelp.d";

export const WhyChooseAirHelp = ({
  sbEditable,
  cards,
  title,
  backgroundColor,
}: SbEditableComponentProps<WhyChooseAirHelpProps>) => (
  <Box backgroundColor={backgroundColor} {...sbEditable}>
    <Container>
      <Stack
        flexDir="column"
        align={{ base: "flex-start", md: "center" }}
        spacing={{ base: 8, md: 16 }}
        px={{ base: 4, md: 8 }}
        pb={{ base: 6, md: 16 }}
        pt={{ base: 8, md: 16, lg: 20 }}
      >
        <Heading as="h2" variant="h2">
          {title}
        </Heading>
        <Flex
          flexDir="column"
          align={{ base: "flex-start", md: "center" }}
          mx={{ base: 0, md: "auto" }}
          pt={{ base: 4, lg: 2 }}
        >
          <Stack
            direction={{ base: "column", md: "row" }}
            spacing={{ base: 8, md: 4, lg: 8 }}
            justify={{ base: "left", md: "center" }}
            align="flex-start"
            maxW={{ base: "100%", lg: "936px" }}
          >
            {cards?.length &&
              cards.map(({ items, backgroundColor, button, title }) => (
                <WhyChooseCard
                  key={title}
                  items={items}
                  backgroundColor={backgroundColor}
                  title={title}
                  button={button}
                />
              ))}
          </Stack>
        </Flex>
      </Stack>
    </Container>
  </Box>
);
